import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import TrafficDashboard from '@pages/dashboard/ui/TrafficDashboard';

export const Route = createFileRoute('/_auth/_layout/dashboard')({
  component: TrafficDashboard,
});
